import { useMyBusiness } from "./useBusiness";
import type { FeatureFlagKey } from "../api/types";

/**
 * Read the effective state of a per-business feature flag.
 *
 * Defaults to `true` when the business hasn't loaded yet or doesn't carry a
 * value for the key. The backend always emits the merged dict on
 * `GET /businesses/me/`, but the fallback keeps the UI safe during the
 * initial query.
 */
export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const { data } = useMyBusiness();
  if (!data) return true;
  const value = data.features?.[key];
  return value === undefined ? true : value;
}
